import axios from "axios/index";

/**
 *
 * @param params
 * @returns {Promise<any | {code: number, message: string}>}
 */
export const getList = params => axios.post('/business/deviceController/list', params).then(res => res ? res.data : {
    code: 500,
    message: '服务器无法连接,请稍后重试'
});
export const detail = params => axios.post('/business/deviceController/detail', params).then(res => res ? res.data : {
    code: 500,
    message: '服务器无法连接,请稍后重试'
});
export const create = params => axios.post('/business/deviceController/create', params).then(res => res ? res.data : {
    code: 500,
    message: '服务器无法连接,请稍后重试'
});
export const update = params => axios.post('/business/deviceController/update', params).then(res => res ? res.data : {
    code: 500,
    message: '服务器无法连接,请稍后重试'
});

//获取中控状态
export const getController = params => axios.post('/business/deviceController/controllerState', params).then(res => res ? res.data : {
    code: 500,
    message: '服务器无法连接,请稍后重试'
});

//修改状态
export const updateState = params => axios.post('/business/deviceController/updateState', params).then(res => res ? res.data : {
    code: 500,
    message: '服务器无法连接,请稍后重试'
});

export const exportTemplate = () => axios.post('/business/deviceController/exportTemplate', null, {
    responseType: 'blob',
    timeout: 20000
}).then(res => res ? res.data : {
    code: 500,
    msg: '服务器无法连接,请稍后重试',
});
export const importFile = formData => axios.post('/business/deviceController/importFile', formData).then(res => res ? res.data : {
    code: 500,
    message: '服务器无法连接,请稍后重试'
});

